import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase';

export function usePageDescription(pageKey: string, defaultText: string) {
  const [description, setDescription] = useState(defaultText);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function fetch() {
      const { data, error } = await supabase
        .from('page_descriptions')
        .select('description')
        .eq('key', pageKey)
        .maybeSingle();

      if (cancelled) return;

      if (data?.description) {
        setDescription(data.description);
      } else {
        setDescription(defaultText);
      }
      setLoading(false);
    }

    fetch();
    return () => { cancelled = true; };
  }, [pageKey, defaultText]);

  const saveDescription = useCallback(async (newText: string) => {
    setSaving(true);
    const { error } = await supabase
      .from('page_descriptions')
      .upsert(
        { key: pageKey, description: newText, updated_at: new Date().toISOString() },
        { onConflict: 'key' },
      );
    setSaving(false);

    if (error) throw error;
    setDescription(newText);
  }, [pageKey]);

  return { description, loading, saving, saveDescription };
}
